import { http } from '@/lib/apiClient';
import type { Notifica, NotificaCategoriaId, NotificheRiepilogo, Paginated, PaginationParams, UUID } from '@/types';

const BASE = '/notifiche';

export interface NotificheListParams extends PaginationParams {
  letta?: boolean;
  categoria?: NotificaCategoriaId;
}

export const notificheService = {
  list(params: NotificheListParams = {}): Promise<Paginated<Notifica>> {
    return http.get<Paginated<Notifica>>(BASE, { params });
  },

  riepilogo(): Promise<NotificheRiepilogo> {
    return http.get<NotificheRiepilogo>(`${BASE}/riepilogo`);
  },

  /** Badge counter, kept as a separate cheap endpoint. */
  unreadCount(): Promise<{ count: number }> {
    return http.get<{ count: number }>(`${BASE}/unread-count`);
  },

  markRead(id: UUID): Promise<Notifica> {
    return http.patch<Notifica>(`${BASE}/${id}/read`);
  },

  markAllRead(): Promise<{ updated: number }> {
    return http.post<{ updated: number }>(`${BASE}/read-all`);
  },
};
